import React, { useRef } from 'react';
import { Box, LightMode, Overlay, ThemeProvider } from '@landr/maestro';
import ConfirmRemoveAllModal from 'components/Modals/ConfirmRemoveAllModal';
import ConfirmLoadSessionModal from 'components/Modals/ConfirmLoadSessionModal';
import { ShareModal } from 'components/Modals/ShareModal';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';
import { creator } from './Creator.styled';
import CreatorCollapse from './CreatorCollapse/CreatorCollapse';

const TransitionDuration = 500;

export interface CreatorTriggerProps {
    isCreatorOpen: boolean;
    onClick: () => void;
}

const _Creator: React.FC<{
    closeCreator: () => void;
    isCreatorOpen: boolean;
    isVisible: boolean;
}> = ({ closeCreator, isCreatorOpen, isVisible }) => {
    // REFS
    const creatorWrapperRef = useRef<HTMLDivElement>(null);

    const classes = creator({ isVisible });

    return (
        <>
            <LightMode>
                <Box
                    className={classes.wrapper}
                    ref={creatorWrapperRef}
                    data-testid="creator"
                    id="creator"
                >
                    <ThemeProvider
                        getRootNode={() => document.getElementById('creator')}
                    >
                        <CreatorCollapse />
                    </ThemeProvider>
                </Box>
                <Overlay
                    isVisible={isCreatorOpen && isVisible}
                    onClick={closeCreator}
                    timeout={TransitionDuration}
                    isContained
                    position="fixed"
                    zIndex={300}
                />
            </LightMode>
            <ConfirmRemoveAllModal />
            <ConfirmLoadSessionModal />
            <ShareModal />
        </>
    );
};

const Creator: React.FC = () => {
    // CONTEXT
    const { state, closeCreator, isVisible } = useCreatorContext();
    const { isCreatorOpen } = state;

    return (
        <_Creator
            isCreatorOpen={isCreatorOpen}
            closeCreator={closeCreator}
            isVisible={isVisible}
        />
    );
};

export default Creator;
